import React from 'react';
import { View } from '@adobe/react-spectrum';
import classnames from 'class-names';
import Close from '@spectrum-icons/workflow/Close';
import styles from './CloseIcon.module.less';
import { withTheme } from '../ThemeProvider';

/**
 * A component used to close modals, etc.
 *
 * @param {{ onClick: React.MouseEventHandler<HTMLDivElement>; className?: string }}
 */
function CloseIcon({ onClick, className }) {
  return (
    <div className={classnames(styles.exit, className)} onClick={onClick}>
      <Close size="XS" />
    </div>
  );
}

export default withTheme(CloseIcon);
